<template>
  <div class="checkout-approved">
    <div class="installment-title" v-apply-theme>
      Escolha um valor de entrada
    </div>
    <DownPaymentList
      id="down-payment-list"
      v-if="downPaymentOptions"
      :loadingValues="downPaymentValueSkeleton"
      :indexSelected="downPaymentIndexSelected"
      @downPaymentChange="onDownpaymentChange"
      :downPaymentOptions="downPaymentOptions"/>
    <div class="installment-title" v-apply-theme>
      Quantidade de parcelas
    </div>
    <InstallmentSelect
      id="installment-select"
      ref="installment-select"
      :indexSelected="installmentIndexSelected"
      v-if="downPaymentSelected"
      @installmentSelect="onInstallmentSelect"
      :installments="downPaymentSelected.options"
    />
    <CheckoutSummary
      v-if="downPaymentSelected"
      :loading="summarySkeleton"
      :downPaymentValue="downPaymentSelected.downPaymentValue"
      :downPaymentPercentage="downPaymentSelected.downPaymentPercentage"
      :totalAmount="installmentSelected && installmentSelected.totalAmount"
      :interestRatePM="installmentSelected && installmentSelected.interestRatePM"
      :cetPA="installmentSelected && installmentSelected.cetPA"
      :oneLineFooter="true"
    />

    <Button
      class="primary checkout-confirm-button"
      :disabled="summarySkeleton || (typeof installmentIndexSelected !== 'number')"
      @click="handleFinishTransaction"
      >
      Finalizar compra
    </Button>

    <div class="return-button" :class="{ mobile: isMobile() }">
      <Button class="link button-link" :class="{ mobile: isMobile() }" :href="checkoutUrl">
        Cancelar e voltar para loja
      </Button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import UtilMixin from '@/mixins/util';
import DownPaymentList from '@/components/common/DownPaymentList.vue';
import InstallmentSelect from '@/components/common/InstallmentSelect.vue';
import Button from '@/components/ui/AppButton.vue';
import { ApplyTheme } from '@/directives/applyTheme';
import CheckoutSummary from '../../checkout/components/CheckoutSummary.vue';

export default {
  name: 'checkout-approved',
  directives: {
    ApplyTheme,
  },
  mixins: [UtilMixin],
  computed: {
    ...mapState('checkoutFallback', [
      'downPaymentIndexSelected',
      'installmentIndexSelected',
      'downPaymentOptions',
      'summarySkeleton',
      'downPaymentValueSkeleton',
      'config',
      'hasPreCondition',
      'confirmUrl',
      'checkoutUrl',
    ]),
    ...mapGetters('checkoutFallback', [
      'downPaymentSelected',
      'installmentSelected',
      'ccbUrl',
    ]),
    confirmText() {
      return (this.config && this.config.confirmText) || 'Pagar parcelado no boleto';
    },
    confirmButton() {
      return (this.config && this.config.confirmButtom) || false;
    },
    showCCBText() {
      return (this.config && this.config.showCCBText) || false;
    },
  },
  methods: {
    ...mapActions('checkoutFallback', [
      'setInstallmentIndex',
      'resetLoading',
      'setDownPaymentIndex',
      'pay',
      'emitEvent',
    ]),
    onDownpaymentChange(index) {
      this.setDownPaymentIndex(index);
    },
    onInstallmentSelect(index) {
      this.setInstallmentIndex(index);
    },
    async handleFinishTransaction() {
      await this.pay();
    },
  },
  components: {
    DownPaymentList,
    InstallmentSelect,
    CheckoutSummary,
    Button,
  },
  mounted() {
    this.resetLoading();
    if (this.hasPreCondition) {
      this.emitEvent({
        type: 'preapproved',
      });
    } else {
      this.emitEvent({
        type: 'approved',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
#installment-select {
  margin-bottom: 20px;
}

#down-payment-list {
  margin-bottom: 20px;
}

.checkout-confirm-button {
  margin-top: 20px;
  margin-bottom: 24px;
  @media (max-width: $md) {
    width: 100%;
    height: 48px;
  }
}

.installment-title, .down-payment-list-title {
  @extend .body-bold;
  margin-bottom: 8px;
  color: var(--gray-600);
  &--vivo {
    font-weight: normal;
  }
}

.ccb-text {
  @extend .x-small-regular;
  margin: 8px 0;
  text-align: center;

  a {
    @extend .primary;
    text-decoration: none;
  }
}
.return-button {
  &.mobile {
    display: flex;
    justify-content: center;
  }
  .button-link {
    font-size: 12px;
    line-height: 16px;
    padding: 0px;
    margin-bottom: 20px;
    &.mobile {
      margin-bottom: 30px;
    }
  }
}
</style>
